import type { WasteFacility } from 'portal/store/interfaces'

import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  facilitiesLoadSuccess,
  facilitiesLoadFailure,
  FACILITIES_LOAD,
  FACILITIES_LOAD_CONTINUATION,
  facilitiesLoadAction,
  facilitiesLoadContinuationAction
} from './actions'

function* facilitiesLoadSaga(action: facilitiesLoadAction) {
  try {
    let facilities: WasteFacility[] = []

    const params: any = {
      'page[size]': 100
    }

    if (action.hint != null && action.hint.length > 0) {
      params['hint'] = action.hint
    }

    if (action.removalDate != null) {
      params['ExpiresAfter'] = action.removalDate
    }

    const response: { data: PagedResponse } = yield call(() =>
      axios.get(`/referencedata/waste/facilities`, {
        params: params
      })
    )

    facilities = response && response.data ? [...response.data.items] : []

    yield put(
      facilitiesLoadSuccess(
        facilities,
        response.data.continuationToken,
        response.data.hasNextPage
      )
    )
  } catch (error) {
    console.error(error)
    yield put(facilitiesLoadFailure(error))
  }
}

function* facilitiesLoadContinuationSaga(
  action: facilitiesLoadContinuationAction
) {
  try {
    let facilities: WasteFacility[] = []

    const params: any = {
      'page[size]': 100
    }

    if (action.hint != null && action.hint.length > 0) {
      params['hint'] = action.hint
    }

    if (action.removalDate != null) {
      params['ExpiresAfter'] = action.removalDate
    }

    const response: { data: PagedResponse } = yield call(() =>
      axios.get(`/referencedata/waste/facilities`, {
        params: params,
        headers: { contToken: action.continuationToken }
      })
    )

    facilities = response && response.data ? [...response.data.items] : []

    yield put(
      facilitiesLoadSuccess(
        facilities,
        response.data.continuationToken,
        response.data.hasNextPage
      )
    )
  } catch (error) {
    console.error(error)
    yield put(facilitiesLoadFailure(error))
  }
}

export function* watch() {
  yield all([
    takeLatest(FACILITIES_LOAD, facilitiesLoadSaga),
    takeLatest(FACILITIES_LOAD_CONTINUATION, facilitiesLoadContinuationSaga)
  ])
}

export interface PagedResponse {
  continuationToken: string
  hasNextPage: boolean
  items: WasteFacility[]
}
